import { render, staticRenderFns } from "./comDtoData2.vue?vue&type=template&id=f61c5274&scoped=true&"
import script from "./comDtoData2.vue?vue&type=script&lang=js&"
export * from "./comDtoData2.vue?vue&type=script&lang=js&"
import style0 from "./comDtoData2.vue?vue&type=style&index=0&id=f61c5274&scoped=true&lang=scss&"
import style1 from "./comDtoData2.vue?vue&type=style&index=1&id=f61c5274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c5274",
  null
  
)

export default component.exports